export function isValidBid(value1, value2) {
  if (!value1 || !value2)
    return false;

  const numericValue1 = parseFloat(value1.toString().replace(/R\$\s*/g, '').replace(/\./g, '').replace(',', '.'));
  const numericValue2 = parseFloat(value2.toString().replace(/R\$\s*/g, '').replace(/\./g, '').replace(',', '.'));

  if (isNaN(numericValue1) || isNaN(numericValue2))
    return false;

  if (numericValue1 === numericValue2)
    return false;

  return numericValue1 > 0;
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js